import { Fragment } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider, Typography } from '@mui/material';

export default function FormDialogDelete(props) {
  if (!props) {
    return <></>;
  }

  const title = props.title ? props.title : "";
  const dataSaveProperty = props.jsonInfo.saveProperty ? props.jsonInfo.saveProperty : "";
  const dataSavePropertyIsArray = props.jsonInfo.savePropertyIsArray ? props.jsonInfo.savePropertyIsArray : false;
  const dataSaveId = props.jsonInfo.saveId ? props.jsonInfo.saveId : 0;

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = [];
    data[dataSaveProperty] = [{}];

    const isItemToDelete = true;
    props.onSave(data, dataSavePropertyIsArray, dataSaveId, isItemToDelete);
    props.onClose();
  };

  return (
    <Fragment>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleSubmit,
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ mb: -1.5 }}>
          <h3>Excluir {title}</h3>
        </DialogTitle>
        <Divider />

        <DialogContent>
          <Typography variant="body1">
            Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>

        <Divider />
        <DialogActions>
          <Button onClick={props.onClose}>Cancelar</Button>
          <Button variant="contained" color="error" type="submit">Excluir</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
